import Api from "..";
import PublicCongress from "../../dtos/congress";
import transform from "../../service/transform";

export default class CongressApi extends Api {
  constructor() {
    super("congress");
  }

  public async get(): Promise<PublicCongress[]> {
    const data = (await super.get()).data;
    if (!Array.isArray(data))
      throw new TypeError("PublicCongress entry list is not an array.");

    return await Promise.all(
      data.map(async (value) => await transform(PublicCongress)(value)),
    );
  }
}
